module.exports = __webpack_public_path__ + "static/fonts/Fact-Condensed.6c6d429.woff2";